import { Button, Icon, Modal, Text } from '@msc-b2c/shared-components';
import clsx from 'clsx';
import styles from './diningmodal.module.scss';
import { DiningModalProps } from '@msc-b2c/interfaces/interfaces';

export default function DiningModal({ modal }: Readonly<{ modal?: DiningModalProps }>) {
  const {
    show = false,
    title,
    description,
    onCancel,
    onConfirm,
    onCancelLabel,
    onConfirmLabel,
    onClose,
  } = modal || {};

  if (!show) return null;

  const isFooterVisible = (onCancel && onCancelLabel) || (onConfirm && onConfirmLabel);

  return (
    <Modal
      shouldRenderBackdrop={true}
      modalIcon={onClose && 'close'}
      onClose={onClose}
      styleOption={clsx('-modal-with-buttons', styles['dining-modal'])}
      hideCloseIcon={true}
    >
      <div className={styles['dining-modal__header']}>
        <Text
          text={title}
          styleOption={'header-xs'}
        />
        {!!onClose && (
          <Icon
            icon="close"
            onClick={onClose}
          />
        )}
      </div>
      <div className={styles['dining-modal__content']}>
        <Text
          text={description}
          styleOption={'body-big'}
        />
      </div>
      {isFooterVisible && (
        <div className={styles['dining-modal__footer']}>
          {!!onCancel && !!onCancelLabel && (
            <Button
              text={onCancelLabel}
              onClick={onCancel}
              styleOption="cmp-button__secondary -no-outline"
            />
          )}
          {!!onConfirm && !!onConfirmLabel && (
            <Button
              text={onConfirmLabel}
              onClick={onConfirm}
              styleOption="cmp-button__primary"
            />
          )}
        </div>
      )}
    </Modal>
  );
}
